export const IMAGES = {
  heroAerial:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/0ce8516d-9bab-4b51-ad31-606e5a15e6ed/DJI_0163.JPG",
  hddCrew:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/b9bd7ca9-bbb4-440f-9111-c7d9f23c1fe8/B91B34BC-53D7-49A5-B37E-2ABF25BA6DA5_20220722000000_photos-1658634880.4038591-3-f9d06e.jpg",
  hddOperator:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/e86e418d-3b76-40e0-a0c2-428267fd1fff/Adam+Raustin.jpg",
  capabilitiesHero:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_tidwell-modern/artifacts/pdxryk5d_IMG_0094.webp",
  careersHero:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_tidwell-modern/artifacts/sj1b00mp_IMG_5057.webp",
  augerBoring:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/3bcc9841-0231-424c-9685-efd0a5bcd148/26643005-D9A5-478D-BC76-1F65B73C15A1_20210730000000_photos-1627778818.5967631-4-510d09.jpg",
  trenching:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/0a7b6d76-3524-4121-bc84-713c1aeb0e3a/IMG_9255.jpg",
  trencher:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/78522ac6-7af8-490f-ae47-fcc8b761a267/IMG_0152+%281%29.jpg",
  fiber:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/b9d61b17-5dca-41e9-a556-2c5429c5932e/IMG_5595.jpg",
  fusing:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/5d8b3940-5297-4654-8b51-eb7bb826d635/IMG_8107.jpg",
  excavator:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/1481738418130-G8I1OCWA8QUD6TD49JI3/IMG_0445.JPG",
  osp:
    "https://images.squarespace-cdn.com/content/v1/552e9cfee4b0dc86eeb15de5/1767976810141-4KKA45U8VHYQQ076RXD9/unsplash-image-fteR0e2BzKo.jpg",
};

export const COMPANY = {
  name: "Leo Tidwell Excavating Corporation",
  short: "LTEC",
  brand: "Tidwell Companies",
  tagline: "Built Beneath California",
  years: "46",
  address: "2000 Dallons Drive, Paso Robles, CA 93447",
  phone: "(805) 238-4612",
  phoneHref: "tel:+18052384612",
  license: "CA #421831 · AZ #327162 · NV #0086504",
};

export const NAV_LINKS = [
  { name: "Capabilities", path: "/capabilities", testId: "nav-link-capabilities" },
  { name: "About", path: "/about", testId: "nav-link-about" },
  { name: "Safety", path: "/safety", testId: "nav-link-safety" },
  { name: "Projects", path: "/projects", testId: "nav-link-projects" },
  { name: "Careers", path: "/careers", testId: "nav-link-careers" },
  { name: "Contact", path: "/contact", testId: "nav-link-contact" },
];

export const SERVICES = [
  {
    id: "underground-utilities",
    num: "01",
    title: "Underground Utilities",
    tag: "Core Infrastructure",
    image: IMAGES.heroAerial,
    alt: "Aerial view of an LTEC underground utility operation in California",
    blurb:
      "Complete substructure construction: plowing, trenching, excavating, directional boring, rodding, pulling, conduit and cable placing, and manhole placement for telephone, power, fiber, and gas.",
    specs: [
      "Joint trench & dry utility substructure",
      "Conduit, fiber and cable placement",
      "Manhole and vault placement",
      "Turnkey OSP buildouts",
    ],
  },
  {
    id: "directional-drilling",
    num: "02",
    title: "Horizontal Directional Drilling",
    tag: "Trenchless HDD",
    image: IMAGES.hddCrew,
    alt: "LTEC directional drilling crew on a pipeline installation",
    blurb:
      "One of the first contractors in the HDD industry over 30 years ago. Bores up to 2,200 feet and pipe diameters up to 36 inches — under rivers, streams, highways, and through mountains.",
    specs: [
      "Bores up to 2,200 ft in length",
      "Pipe diameters up to 36 inches",
      "Rock boring with mud motors & recyclers",
      "PVC, HDPE, SDR 35, C900 & steel installs",
    ],
  },
  {
    id: "auger-boring",
    num: "03",
    title: "Auger Boring",
    tag: "Jack & Bore",
    image: IMAGES.augerBoring,
    alt: "Auger boring machine installing steel casing in a deep pit",
    blurb:
      "A reliable, low-impact solution for crossing paved surfaces, rail corridors, and other sensitive areas — protecting infrastructure and minimizing disruption while delivering long-term utility performance.",
    specs: [
      "Steel casing installations on grade",
      "Rail corridor & paved surface crossings",
      "Low-impact, minimal surface disruption",
      "Experienced pit crews & planning",
    ],
  },
  {
    id: "trenching",
    num: "04",
    title: "High-Production Trenching",
    tag: "Rock & Soil",
    image: IMAGES.trenching,
    alt: "High-production utility trenching through rugged California terrain",
    blurb:
      "A Ditch Witch RT185 for high-volume dirt work — up to 7,000 linear feet per day — and a Vermeer T658 track trencher with rock chains that cuts 12 to 24 inches wide, even through asphalt.",
    specs: [
      "Up to 7,000 LF per day (RT185)",
      "Rock chains from 12\" to 24\" wide (T658)",
      "Trench in asphalt & self-load trucks",
      "Ground asphalt reused as backfill",
    ],
  },
  {
    id: "fiber-copper",
    num: "05",
    title: "Fiber & Copper Placing / Splicing",
    tag: "Telecom OSP",
    image: IMAGES.fiber,
    alt: "Fiber optic cable placement equipment in the field",
    blurb:
      "Geared up for fiber since 2000: seven fiber-blowing machines with air coolers, seven power pacs, three hydraulic mid-assist units, Hogg-Davis cable trailers, and winch trucks.",
    specs: [
      "7 fiber-blowing machines w/ air coolers",
      "Hydraulic mid-assist placement",
      "Install or remove copper & fiber cable",
      "Reel trailers & winch truck support",
    ],
  },
  {
    id: "vacuum-potholing",
    num: "06",
    title: "Vacuum Potholing",
    tag: "Utility Locating",
    image: IMAGES.trencher,
    alt: "Heavy track trencher in the LTEC fleet yard",
    blurb:
      "Trailer-mounted Jet Vacs use high-pressure water and vacuum pumps to positively locate existing utilities — an eight-inch hole, ten feet deep, in as little as ten minutes, with no damage risk.",
    specs: [
      "Positive location of buried utilities",
      "High-pressure water & vacuum excavation",
      "8\" holes to 10 ft depth in minutes",
      "Zero damage to existing facilities",
    ],
  },
  {
    id: "design-build-osp",
    num: "07",
    title: "Design-Build OSP",
    tag: "Turnkey Networks",
    image: IMAGES.osp,
    alt: "Outside plant telecommunications infrastructure",
    blurb:
      "Complete outside-plant buildouts with fiber, copper, or both — turnkey from concept to finished product, backed by 46 years of underground utility experience.",
    specs: [
      "Concept-to-completion delivery",
      "Fiber, copper, or hybrid networks",
      "Single accountable contractor",
      "Proposals on large-scale projects",
    ],
  },
  {
    id: "hdpe-fusing",
    num: "08",
    title: "HDPE Pipe Fusing",
    tag: "Fusion Certified",
    image: IMAGES.fusing,
    alt: "HDPE butt fusion machine joining pipe on site",
    blurb:
      "In-house butt fusion and electrofusion for HDPE and fusible C-900 — two butt fusion machines and three electrofusion machines joining pipe up to twelve inches in diameter.",
    specs: [
      "2 butt fusion machines",
      "3 electrofusion machines",
      "Pipe up to 12\" diameter",
      "HDPE & fusible C-900",
    ],
  },
];

export const MARQUEE_ITEMS = [
  "Underground Utilities",
  "Horizontal Directional Drilling",
  "Auger Boring",
  "High-Production Trenching",
  "Fiber & Copper OSP",
  "Vacuum Potholing",
  "HDPE Fusing",
  "Built Beneath California",
];

export const MARKETS = [
  "Telephone",
  "Power",
  "Fiber",
  "Gas",
  "Dry Utilities",
  "OSP Buildouts",
];

export const CUSTOMERS = [
  "Verizon",
  "AT&T",
  "PG&E",
  "SCE",
  "Lumen",
  "Level 3",
  "Sprint",
  "MCI",
  "SBC",
  "The Gas Company",
  "Wave Broadband",
  "Astound",
];

export const SERVICE_AREA = [
  "Coast to the Nevada border",
  "San Jose to Los Angeles",
  "Bakersfield to Sacramento",
  "Lancaster to Bishop",
  "Nevada & Arizona project support",
  "Any project in California, Nevada & Arizona considered",
];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
